<div class="product-selection">
  @if (ruleGroupsArray) {
    @for (ruleGroup of ruleGroupsArray.controls; track ruleGroup; let i = $index) {
      @if (i > 0) {
        <div class="or-separator"><span class="or-separator__text">OR</span></div>
      }
      <smart-cart-upsell-rule-group
        [formGroup]="getRuleGroupFormGroup(i)"
        [index]="i"
        [canRemove]="ruleGroupsArray.length > 1"
        [shopCurrencySymbol]="shopCurrencySymbol"
        (remove)="removeRuleGroup(i)"
        (duplicate)="duplicateRuleGroup(i)">
      </smart-cart-upsell-rule-group>
    }
  }

  <button type="button" class="add-rule-group-btn" (click)="addRuleGroup()">+ Add Rule Group</button>

  <smart-cart-upsell-appearance [formGroup]="formGroup" [globalSettingsFormGroup]="globalSettingsFormGroup">
  </smart-cart-upsell-appearance>

  <!-- Custom code — reuses the shared widget custom-code card (bound to settings.customCode). -->
  @if (customCodeGroup) {
    <smart-cart-form-custom-code
      [enabledControl]="customCodeGroup.controls.enabled"
      [codeControl]="customCodeGroup.controls.code"
      [defaultCode]="customCodeDefault"
      [variables]="customCodeVariables"></smart-cart-form-custom-code>
  }
</div>
